export default __webpack_public_path__ + "static/media/24.c60aad19.mp3";